
import VueApexCharts from "vue-apexcharts";
// import dayjs from "dayjs";
export default {
  name: "GraficosVendas",
  components: {
    VueApexCharts,
  },
  props: {
    dados: Array,
    quantidade: Boolean,
    valor: Boolean,
    periodo: Boolean,
    relatorio: Array,
  },

  computed: {
    seriesValor() {
      return this.dados.length ? this.dados.map((i) => i.valorTotal) : [0];
    },
    seriesQuantidade() {
      return this.dados.length
        ? this.dados.map((i) => i.quantidadeDeVendas)
        : [0];
    },
    labels() {
      return this.dados.length ? this.dados.map((i) => i.vendedor) : [0];
    },
    // labelPeriodo() {
    //   let diasEValores = this.relatorio.map((i) => ({
    //     dia: dayjs(i.abertura).format("DD/MM/YYYY"),
    //     valor: i.valor_adesao,
    //   }));
    //   let dias = diasEValores.map(i=> i.dia)
    //   let diasFiltrados = [...new Set(...dias)];

    //   return labels;
    // },
  },
};
